module.exports = __webpack_public_path__ + "assets/b30.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b30.png
// module id = 617
// module chunks = 0